import SafeScreen from "components/shared/SafeScreen";
import { useEffect } from "react";

const FullscreenTest = () => {
	useEffect(() => {
		const setVh = () => {
			const vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		};
		setVh();
		window.addEventListener("resize", setVh);
		window.addEventListener("orientationchange", setVh);
		return () => {
			window.removeEventListener("resize", setVh);
			window.removeEventListener("orientationchange", setVh);
		};
	}, []);

	return (
		<SafeScreen>
			<div style={{ background: "white", padding: 16 }}>
				I should not be cropped
			</div>
		</SafeScreen>
	);
};

export default FullscreenTest;
